"use client"

import { useEffect } from 'react'

interface StylesReadyProviderProps {
  children: React.ReactNode
}

export function StylesReadyProvider({ children }: StylesReadyProviderProps) {
  useEffect(() => {
    const addStylesReadyClass = () => {
      document.body.classList.add('styles-ready')
    }

    // If document is already ready, add class immediately
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      addStylesReadyClass()
    } else {
      // Wait for DOM to be ready
      const handleDOMReady = () => {
        addStylesReadyClass()
      }

      document.addEventListener('DOMContentLoaded', handleDOMReady)
      
      // Fallback: add class after a short delay
      const timer = setTimeout(addStylesReadyClass, 50)

      return () => {
        document.removeEventListener('DOMContentLoaded', handleDOMReady)
        clearTimeout(timer)
        document.body.classList.remove('styles-ready')
      }
    }

    return () => {
      document.body.classList.remove('styles-ready')
    }
  }, [])

  return <>{children}</>
} 